export async function readFile(filename) {
    const response = await fetch(filename);

    if (!response.ok) {
        throw new Error(`Fail to fetch file: ${response.statusText}`);
    }
    const text = await response.text();

    return text.split("\n");
}

export async function readJsonFile(filename) {
    const response = await fetch(filename);

    if (!response.ok) {
        throw new Error(`Fail to fetch file: ${response.statusText}`);
    }
    return await response.json();
}